export const BUTTON_TYPE_BLUE = 'blue';
export const BUTTON_TYPE_GREY = 'grey';